'use client';

import Accordion from '@/components/legacy/header/Accordion';
import Icon from '@/components/shared/Icons';
import React, { useState } from 'react';

interface PromotionDatesListProps {
  promotionDates: JSX.Element[];
  eligibleDatesString: string;
}

export default function PromotionDatesList({ promotionDates, eligibleDatesString }: PromotionDatesListProps) {
  const [isAccordionCollapsed, setIsAccordionCollapsed] = useState<boolean>(true);
  return promotionDates.length === 1 ? (
    <div className="flex">
      <Icon id="calendar" className="h-4 w-4 fill-neutral-60" />
      <ul className="py-0.5 text-neutral-60">{promotionDates}</ul>
    </div>
  ) : (
    <Accordion
      accordionText={eligibleDatesString}
      accordionStyles={{
        contentClassName: '',
        accordionTextClassName: 'pl-2 text-neutral-60',
        accordionIconClassName: 'h-5 w-5 ml-2 fill-[#bcbdbf]'
      }}
      isAccordionCollapsed={isAccordionCollapsed}
      setIsAccordionCollapsed={setIsAccordionCollapsed}
      iconId="calendar"
      chevronLeft={false}
      testID="promotion-tag-eligible-dates-accordion"
    >
      <ul className="py-0.5 text-neutral-60">{promotionDates}</ul>
    </Accordion>
  );
}
